import React, {
    useState,
    useEffect
}
from "react";


import evaImage
from "../../eva/images/eva_person.png";


import evaBanner
from "../../eva/images/banner.png";

import {
    useHistory
}
from "react-router-dom";


//========================================================
// Delivery EVA Panel
//========================================================

export default function DeliveryEvaPanel()
{
	
	//--------------------------------------------------------
    // Router
    //--------------------------------------------------------

    const history =
        useHistory();

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [ready, setReady] =
        useState(false);


    const [hover, setHover] =
        useState(false);


    //--------------------------------------------------------
    // Entrance
    //--------------------------------------------------------

    useEffect(
        function()
        {

            const timer =
                setTimeout(
                    function()
                    {

                        setReady(true);

                    },
                    1440
                );


            return function()
            {

                clearTimeout(timer);

            };

        },
        []
    );




    //--------------------------------------------------------
    // Open EVA
    //--------------------------------------------------------

    const openEva =
        () =>
        {

			history.push(
               "/eva"
           );

        };




 

    //--------------------------------------------------------
    // Styles
    //--------------------------------------------------------

    const evaContainer =
    {

        display:
            "flex",

        position:
            "relative",

        width:
            "calc(100% - 20px)",

        height:
            "170px",

        marginTop:
            "15px",

        marginLeft:
            "10px",

        background:
            "linear-gradient(180deg, #302047 0%, #21182e 55%, #17151d 100%)",

        borderRadius:
            "6px",

        overflow:
            "hidden",

        cursor:
            "pointer",

        boxShadow:
            hover
                ?
                "0 14px 34px rgba(74,45,120,.34)"
                :
                "0 8px 24px rgba(0,0,0,.24)",

        opacity:
            ready
                ?
                1
                :
                0,

        transform:
            ready
                ?
                hover
                    ?
                    "translateY(-3px)"
                    :
                    "translateY(0px)"
                :
                "translateY(16px)",

        transition:
            "opacity .6s ease, transform .25s ease, box-shadow .25s ease"

    };




    //--------------------------------------------------------
    // Watermark
    //--------------------------------------------------------

    const watermarkStyle =
    {

        position:
            "absolute",

        inset:
            0,

        backgroundImage:
            `url(${evaBanner})`,

        backgroundSize:
            "cover",

        backgroundPosition:
            "center",

        backgroundRepeat:
            "no-repeat",

        opacity:
            0.20,

        pointerEvents:
            "none",

        zIndex:
            0

    };




    //--------------------------------------------------------
    // Image Container
    //--------------------------------------------------------

    const imageContainer =
    {

        position:
            "relative",

        zIndex:
            1,

        width:
            "145px",

        display:
            "flex",

        justifyContent:
            "center",

        alignItems:
            "center",

        flexShrink:
            0

    };




    //--------------------------------------------------------
    // EVA Image
    //--------------------------------------------------------

    const imageStyle =
    {

        width:
            "112px",

        height:
            "112px",

        borderRadius:
            "50%",

        objectFit:
            "cover",

        objectPosition:
            "center top",

        border:
            "3px solid rgba(255,255,255,.35)",

        boxShadow:
            "0 10px 28px rgba(0,0,0,.32)",

        filter:
            "contrast(1.04) saturate(1.04)"

    };




    //--------------------------------------------------------
    // Right Content
    //--------------------------------------------------------

    const rightContent =
    {

        position:
            "relative",

        zIndex:
            1,

        display:
            "flex",

        flexDirection:
            "column",

        justifyContent:
            "center",

        flex:
            1,

        padding:
            "18px 54px 18px 4px"

    };




    //--------------------------------------------------------
    // Title
    //--------------------------------------------------------

    const titleStyle =
    {

        color:
            "#ffffff",

        fontSize:
            "22px",

        fontWeight:
            700,

        letterSpacing:
            ".2px",

        marginBottom:
            "3px",

        textShadow:
            "0 2px 8px rgba(0,0,0,.15)"

    };




    //--------------------------------------------------------
    // Subtitle
    //--------------------------------------------------------

    const subtitleStyle =
    {

        color:
            "rgba(255,255,255,.76)",

        fontSize:
            "13px",

        fontWeight:
            500,

        marginBottom:
            "10px"

    };




    //--------------------------------------------------------
    // Description
    //--------------------------------------------------------

    const descriptionStyle =
    {

        margin:
            0,

        maxWidth:
            "340px",

        color:
            "rgba(255,255,255,.92)",

        fontSize:
            "13px",

        lineHeight:
            "19px",

        fontWeight:
            400

    };




    //--------------------------------------------------------
    // Arrow
    //--------------------------------------------------------

    const arrowStyle =
    {

        position:
            "absolute",

        zIndex:
            2,

        right:
            "18px",

        bottom:
            "15px",

        width:
            "30px",

        height:
            "30px",

        borderRadius:
            "50%",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        background:
            hover
                ?
                "rgba(255,255,255,.24)"
                :
                "rgba(255,255,255,.16)",

        border:
            "1px solid rgba(255,255,255,.20)",

        color:
            "#ffffff",

        fontSize:
            "20px",

        fontWeight:
            400,

        transform:
            hover
                ?
                "translateX(3px)"
                :
                "translateX(0px)",

        transition:
            "transform .2s ease, background .2s ease"

    };




    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <>

            {/*============================================
                EVA Panel
            ============================================*/}

            <div
                style={evaContainer}

                onClick={
                    openEva
                }

                onMouseEnter={
                    () =>
                    {

                        setHover(true);

                    }
                }

                onMouseLeave={
                    () =>
                    {

                        setHover(false);

                    }
                }
            >


                {/*========================================
                    EVA Banner Watermark
                ========================================*/}

                <div
                    style={watermarkStyle}
                />




                {/*========================================
                    EVA
                ========================================*/}

                <div
                    style={imageContainer}
                >

                    <img
                        src={evaImage}
                        style={imageStyle}
                        alt="EVA"
                    />

                </div>




                {/*========================================
                    Content
                ========================================*/}

                <div
                    style={rightContent}
                >

                    <div
                        style={titleStyle}
                    >

                        Meet Eva

                    </div>


                    <div
                        style={subtitleStyle}
                    >

                        Your Intelligent Estate Assistant

                    </div>


                    <p
                        style={descriptionStyle}
                    >

                        Explore your estate, find documents and compliance
                        information, and get instant answers from your
                        property data.

                    </p>

                </div>




                {/*========================================
                    Arrow
                ========================================*/}

                <div
                    style={arrowStyle}
                >

                    ›

                </div>

            </div>





        </>

    );

}